import { PlatformType } from "../../../types/baseTypes";
import styles from "./Socials.module.scss";

import { ReactSVG } from "react-svg";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { CustomLink } from "@/components/CustomLink";

interface SocialsProps {
  platforms: PlatformType;
  headline?: string;
}

export const Socials = ({ platforms }: SocialsProps) => {
  const { getLabel } = useGlobalContext();

  return (
    <ul
      className={`social-menu ${styles["social-menu"]}`}
      role="menubar"
      aria-label={getLabel(
        "aria_label_socials_list",
        "Links zu meinen Social‑Media‑Profilen",
      )}
    >
      {Array.isArray(platforms) &&
        platforms.map((social, key) => {
          const arialLabel = getLabel("aria_label_socials")?.replace(
            `"$title_social_network"`,
            social.name || "",
          );

          const icon = social?.icon?.url && (
            <ReactSVG
              width={"100%"}
              height={"100%"}
              src={social.icon?.url || ""}
              wrapper={"svg"}
              beforeInjection={(svg) => {
                svg.setAttribute("alt", `${social.name} Icon`);
                svg.setAttribute("title", `${social.name} Icon`);
                svg.setAttribute("aria-label", `${social.name} Icon`);
              }}
              role="link"
              aria-label={`${social.name} link`}
              // color="red"
            />
          );

          if (social?.name && social?.show_navbar) {
            return (
              <li key={key} role="none" className={styles["social-icon"]}>
                {social.link && (
                  <CustomLink
                    className={styles["social-link"]}
                    target="_blank"
                    href={social.link}
                    aria-label={arialLabel}
                    role="menuitem"
                  >
                    {icon}
                  </CustomLink>
                )}
              </li>
            );
          }
        })}
    </ul>
  );
};
